import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { tap } from 'rxjs/operators';
import { StingrayAuthenticationService } from '../stingray-authentication.service';

export const authenticationGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const stingrayAuthenticationService = inject(StingrayAuthenticationService);
  return stingrayAuthenticationService.isAuthenticated$.pipe(
    tap(loggedIn => {
      if (!loggedIn) {
        stingrayAuthenticationService.login(state.url);
      }
    })
  );
};
